import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../../constants/apiPath";
import axios from "axios";
import { startLoading, stopLoading } from "../loader/loaderSlice";

const initialState = {
  isLoading: false,
  products: [],
};
const THUNK_METHODS = {
  WISTLIST_ADD_REMOVE: "user/wistlist/addor/remove",
  WISTLIST_GET: "user/wistlist",
};

export const addProductToWishlist = createAsyncThunk(
  THUNK_METHODS.WISTLIST_ADD_REMOVE,
  async (productId,{ dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}${API.WHISHLIST.ADD}`,
        withCredentials: true,
        data: {id: productId},
      });
      return ;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const getWishlistProducts = createAsyncThunk(
  THUNK_METHODS.WISTLIST_GET,
  async (productId,{ dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const {data: {wishlist}} = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.WHISHLIST.GET}`,
        withCredentials: true,
      });
      return wishlist.products;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("Wishlist failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);


export const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(addProductToWishlist.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addProductToWishlist.fulfilled, (state, action) => {
      state.isLoggedIn = false;
    });
    builder.addCase(addProductToWishlist.rejected, (state) => {
      state.isLoggedIn = false;
    });
    builder.addCase(getWishlistProducts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getWishlistProducts.fulfilled, (state, action) => {
      state.products = action.payload;
      state.isLoggedIn = false;
    });
    builder.addCase(getWishlistProducts.rejected, (state) => {
      state.products = [];
      state.isLoggedIn = false;
    });
  },
});
export const {  } = wishlistSlice.actions;
